import React, {Component} from 'react';

class HorizontalAds extends Component {
    render() {
        return (

            <div>
                <ins className="adsbygoogle"
                     style={{display:'inline-block',width:'728px',height:'90px'}}
                     data-ad-client="ca-pub-2641884796904342"
                     format=''
                     data-ad-slot="7748759017">
                </ins>
            </div>
        );
    }
}
export default HorizontalAds;



// WEBPACK FOOTER //
// ./src/components/ads/HorizontalAds.js